import { MessageBar, MessageBarType, Spinner, Stack } from "@fluentui/react";
import { useCallback, useEffect, useState } from "react";

import ContractLogRow from "./ContractLogRow";
import { ContractOccurrence } from "./ContractOccurrences.interfaces";

import { useApi } from "@/core/libs/api/react-query/useApi";

interface ContractOccurrencesProps {
  contractId: string;
}

function ContractOccurrences({ contractId }: ContractOccurrencesProps) {
  const [contractOccurrences, setContractOccurrences] = useState<
    ContractOccurrence[]
  >([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [messageBarProps, setMessageBarProps] = useState<{
    message: string;
    type: MessageBarType;
  }>({
    message: "Não há histórico para este contrato.",
    type: MessageBarType.info
  });
  const { execute } = useApi();

  const getContractOccurrences = useCallback(
    async (id: string) => {
      setIsLoading(true);

      const response = await execute<ContractOccurrence[]>({
        url: `contracts/${id}/occurrences`
      });

      if (!response.response.ok) {
        setMessageBarProps({
          message: "Houve um erro ao buscar o histórico deste contrato.",
          type: MessageBarType.error
        });
      } else {
        setContractOccurrences(response.data);
      }

      setIsLoading(false);
    },
    [execute]
  );

  useEffect(() => {
    void getContractOccurrences(contractId);
  }, [contractId, getContractOccurrences]);

  const RenderContractOccurrences = () => {
    if (isLoading) {
      return <Spinner label="Carregando histórico do contrato..." />;
    }

    if (!contractOccurrences?.length) {
      return (
        <MessageBar messageBarType={messageBarProps.type}>
          {messageBarProps.message}
        </MessageBar>
      );
    }

    return contractOccurrences.map(occurrence => {
      return <ContractLogRow key={occurrence.id} occurrence={occurrence} />;
    });
  };

  return (
    <Stack styles={{ root: { padding: 16 } }}>
      {RenderContractOccurrences()}
    </Stack>
  );
}

export default ContractOccurrences;
